@if (status) {
  <div class="product-availability">
    <img src="assets/images/availability/{{status}}.png"
      title="{{ stockLevel > 0 ? (stockText | cxTranslate : { amount: stockLevel }) : ('product.availability.' + status | cxTranslate : { calendarWeek: nextDeliveryTimeCW }) }}" />
      @if (!iconOnly) {
        <span
          class="product-availability__label"
        >{{ "product.availability." + status | cxTranslate : { calendarWeek: nextDeliveryTimeCW } }}</span>
      }
    </div>
  }
